<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            class="mx-2"
          >
            Принять заявление
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Принять заявление</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <form>
                <v-text-field
                  v-model="number"
                  label="Номер на портале"
                  clearable
                  maxlength="5"
                ></v-text-field>
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">Закрыть</v-btn>
            <v-btn color="green darken-1" text @click="submit">Сохранить</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
  import  Vue from 'vue'

  export default {
    components: {},

    name: "messege_done",
    data: () => ({
      number: '',
      dialog: false,
    }),
    props: ['application_id'],
    methods: {
      submit() {
        const {number, application_id} = this;

        Vue.axios.post('operator/is_done/', {number, application_id})
          .then(function () {
            console.log('SUCCESS!!');
          })
          .catch(function () {
            console.log('FAILURE!!');
          });
        this.$router.push('/operator_profile');
      }
    }
  }
</script>

<style scoped>

</style>
